import {
  ArticleSchema,
  WebPageSchema,
  FaqSchema,
  OrganizationSchema,
} from "./types";

// Helper functions to create specific schema types
export const createWebPageSchema = (
  data: Omit<WebPageSchema, "@type">,
): WebPageSchema => ({
  "@type": "WebPage",
  ...data,
});

export const createArticleSchema = (
  data: Omit<ArticleSchema, "@type">,
): ArticleSchema => ({
  "@type": "Article",
  ...data,
});

export const createBreadcrumbSchema = (
  items: Array<{ name: string; url: string; position: number }>,
) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map((item) => ({
    "@type": "ListItem",
    position: item.position,
    name: item.name,
    item: item.url,
  })),
});

export const createFAQSchema = (
  questions: Array<{ question: string; answer: string }>,
): FaqSchema => ({
  "@type": "FAQPage",
  mainEntity: questions.map((q) => ({
    "@type": "Question",
    name: q.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: q.answer,
    },
  })),
});

export const createOrganizationSchema = (
  data: Omit<OrganizationSchema, "@type">,
): OrganizationSchema => ({
  "@type": "Organization",
  ...data,
});

export const createProductSchema = (data: {
  name: string;
  description: string;
  image: string;
  url: string;
  brand: string;
  sku?: string;
  offers?: {
    price: string;
    priceCurrency: string;
    availability?: string;
    url?: string;
  };
}) => ({
  "@type": "Product",
  ...data,
  brand: {
    "@type": "Brand",
    name: data.brand,
  },
  offers: data.offers
    ? {
        "@type": "Offer",
        ...data.offers,
        availability: data.offers.availability || "https://schema.org/InStock",
      }
    : undefined,
});

export const createServiceSchema = (data: {
  name: string;
  description: string;
  url: string;
  provider: string;
  areaServed?: string;
  serviceType?: string;
}) => ({
  "@type": "Service",
  ...data,
  provider: {
    "@type": "Organization",
    name: data.provider,
  },
});
